<template>
  <div class="page-rule">
    <navigation>规则</navigation>
    <div class="rule-content">
      <div class="content-main">
        <p class="title">金融权益</p>
        <p class="info">（1）授信重审特权：天美贷提现被拒后，会员有效期内可享天美贷授信重审机会1次；</p>
        <p class="info">（2）专属贷款产品推荐：会员有效期内，可获得至少3家贷款产品推荐；</p>
        <p class="info">（3）拒就赔特权：会员有效期内，在推荐的贷款产品授信被拒，可提供2家被拒的产品截图，于会员有效期内联系天美贷客服申请退卡；生活权益一经使用概不能退卡。</p>
        <p class="title">生活权益</p>
        <p class="info">（1）热门视频会员：会员有效期内，可免费领取芒果tv会员周卡1次；</p>
        <p class="info">（2）星巴克35元券：20元购买价值35元星巴克中杯咖啡券，会员有效期内可享1次；</p>
        <p class="info">（3）猫眼电影10元券：7元购买10元猫眼电影券，会员有效期内可享1次；</p>
        <p class="info">（4）5折洁牙：免费领取价值120元的5折洁牙券。</p>
        <p class="title">会员有效期</p>
        <p class="info">自购买日起30日内有效</p>
      </div>
      <div class="content-tips">活动最终解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page-rule {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #27202E;
  .nd-navigation{
    flex: 0 0 auto;
  }
  .rule-content{
    padding: 40px;
    background-color: #27202E;
    .content-main{
      background-color: #fff;
      border-radius: 30px;
      padding: 30px 25px 70px;
      .title{
        font-size: 32px;
        color: #333333;
        margin: 50px 0 10px;
        line-height: 45px;
        font-weight: bold;
      }
      .info{
        font-size: 26px;
        color: #666666;
        line-height: 37px;
      }
    }
    .content-tips{
      font-size: 26px;
      color: #706B75;
      text-align: center;
      margin-top: 60px;
    }
  }
}
</style>